import React, { useState } from "react";
import { Flex, Input, Label, Button } from "@aws-amplify/ui-react";
import "./Register.style.css";
import { IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ImagePicker from "../components/ImagePicker";
import {
  fetchAuthSession,
  getCurrentUser,
  updateUserAttributes,
} from "aws-amplify/auth";
import { RoutesConfig } from "../router/types";
import { uploadData } from "aws-amplify/storage";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { toast } from "react-toastify";
import CropperModal from "../components/CropperModal";

export const Register: React.FC = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [image, setImage] = useState<File>();
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [originalFile, setOriginalFile] = useState<File | null>(null);
  const [showCropper, setShowCropper] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // const handleImageSelect = (file: any) => {
  //   setImage(file);
  // };

  const uploadImage = async () => {
    if (!image) {
      console.error("Nenhuma imagem selecionada.");
      return;
    }

    const session = await fetchAuthSession();
    const userSub = session?.userSub;

    if (!userSub) {
      console.error("Usuário não logado ou sub não encontrado.");
      return;
    }

    const uploadResult = await uploadData({
      path: `${userSub}.png`,
      data: image,
      options: {
        contentType: "image/png",
        bucket: { bucketName: "amazon-dispatcher", region: "us-east-1" },
      },
    });

    await uploadResult.result;

    console.log("Upload concluído!", uploadResult);
  };

  function getPublicUrl(bucketName: string, key: any) {
    return `https://${bucketName}.s3.us-east-1.amazonaws.com/${key}`;
  }

  const handleFirstLogin = async (name: string): Promise<void> => {
    if (!firstName.trim() || !lastName.trim()) {
      toast.error("Por favor, preencha o nome e o sobrenome.");
      return;
    }

    try {
      let imageUrl: any = image;

      if (image) {
        await uploadImage();

        const session = await fetchAuthSession();
        const userSub = session?.userSub;

        if (userSub) {
          imageUrl = getPublicUrl("amazon-dispatcher", `${userSub}.png`);
        }
      }

      await updateUserAttributes({
        userAttributes: {
          name: name,
          picture: imageUrl ?? "",
        },
      });
      await getCurrentUser();
      console.log("Atributos atualizados com sucesso!");
      navigate(RoutesConfig.HOME.path);
      setImage(undefined);
      setCroppedImage(null);
      setOriginalFile(null);
      setShowCropper(false);
    } catch (error) {
      console.error("Erro no processo de primeiro login:", error);
    }
  };

  const handleBack = () => {
    navigate(RoutesConfig.SPLASH.path);
  };

  const handleImageSelect = (file: File) => {
    setOriginalFile(file);
    setShowCropper(true);
  };

  const handleCropComplete = (blob: Blob) => {
    const previewUrl = URL.createObjectURL(blob);
    const extension = blob.type.split("/")[1];
    const croppedFile = new File([blob], `cropped_image.${extension}`, {
      type: blob.type,
    });

    setCroppedImage(previewUrl);
    setImage(croppedFile);
    setShowCropper(false);
  };

  const handleCancelCrop = () => {
    setShowCropper(false);
  };

  return (
    <div className="split-screen">
      <div className="left-side-register">
        <img src="/fundoLogin.png" alt="Login Illustration" className="image" />
      </div>
      <div className="right-side-register">
        <Flex
          direction="column"
          gap={3}
          width={isMobile ? "100vw" : 420}
          borderRadius={isMobile ? "17px" : 0}
          padding={isMobile ? "20px" : 0}
          backgroundColor={
            isMobile ? "white !important" : "transparent !important"
          }
        >
          <IconButton
            onClick={handleBack}
            sx={{
              position: "absolute",
              top: 16,
              left: 16,
              zIndex: 1,
            }}
          >
            <ArrowBackIosNewIcon
              style={{ color: isMobile ? "white" : "#0A0C33" }}
            />
          </IconButton>
          <Typography
            variant="h6"
            align="center"
            className="register-title"
            style={{ color: "black !important" }}
          >
            Concluir Cadastro
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
            }}
          >
            <ImagePicker
              imagePreview={croppedImage || null}
              onImageSelect={handleImageSelect}
            />
            {showCropper && originalFile && (
              <CropperModal
                image={URL.createObjectURL(originalFile)}
                onCropComplete={handleCropComplete}
                onCancel={handleCancelCrop}
              />
            )}
          </div>
          <Flex
            direction="column"
            gap="small"
            alignItems="flex-start"
            style={{ marginTop: "10px" }}
          >
            <Label htmlFor="firstName">
              Primeiro Nome:<span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              isRequired
              id="firstName"
              name="firstName"
              placeholder="Digite seu primeiro nome"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              style={{ textAlign: "left" }}
            />
          </Flex>

          <Flex
            direction="column"
            gap="small"
            alignItems="flex-start"
            style={{ marginTop: "10px" }}
          >
            <Label htmlFor="lastName">
              Último Nome:<span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              isRequired
              id="lastName"
              name="lastName"
              placeholder="Digite seu sobrenome"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              style={{ textAlign: "left" }}
            />
          </Flex>

          <div style={{ textAlign: "right" }}>
            <Button
              className="btn-cadastrar"
              type="submit"
              onClick={() => {
                const fullName = `${firstName} ${lastName}`.trim();
                handleFirstLogin(fullName);
              }}
            >
              Prosseguir
            </Button>
          </div>
        </Flex>
      </div>
    </div>
  );
};
